const getters = {
    appliedFiltersCount: state => state.appliedFiltersCount,
};

export default getters;